import { MonthlyPrayerTimes } from '../types';

export const septemberPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "03:34",
    shoruk: "05:37",
    dhuhr: "12:53",
    asr: "16:35",
    maghrib: "19:58",
    isha: "21:54"
  },
  2: {
    fajr: "03:35",
    shoruk: "05:40",
    dhuhr: "12:53",
    asr: "16:33",
    maghrib: "19:56",
    isha: "21:53"
  },
  3: {
    fajr: "03:35",
    shoruk: "05:42",
    dhuhr: "12:52",
    asr: "16:31",
    maghrib: "19:53",
    isha: "21:52"
  },
  4: {
    fajr: "03:36",
    shoruk: "05:44",
    dhuhr: "12:52",
    asr: "16:29",
    maghrib: "19:50",
    isha: "21:51"
  },
  5: {
    fajr: "03:37",
    shoruk: "05:47",
    dhuhr: "12:52",
    asr: "16:27",
    maghrib: "19:47",
    isha: "21:50"
  },
  6: {
    fajr: "03:38",
    shoruk: "05:49",
    dhuhr: "12:51",
    asr: "16:26",
    maghrib: "19:44",
    isha: "21:49"
  },
  7: {
    fajr: "03:38",
    shoruk: "05:51",
    dhuhr: "12:51",
    asr: "16:24",
    maghrib: "19:41",
    isha: "21:48"
  },
  8: {
    fajr: "03:39",
    shoruk: "05:53",
    dhuhr: "12:51",
    asr: "16:22",
    maghrib: "19:38",
    isha: "21:47"
  },
  9: {
    fajr: "03:40",
    shoruk: "05:56",
    dhuhr: "12:50",
    asr: "16:20",
    maghrib: "19:35",
    isha: "21:43"
  },
  10: {
    fajr: "03:41",
    shoruk: "05:58",
    dhuhr: "12:50",
    asr: "16:18",
    maghrib: "19:32",
    isha: "21:39"
  },
  11: {
    fajr: "03:42",
    shoruk: "06:00",
    dhuhr: "12:50",
    asr: "16:16",
    maghrib: "19:29",
    isha: "21:35"
  },
  12: {
    fajr: "03:42",
    shoruk: "06:02",
    dhuhr: "12:49",
    asr: "16:14",
    maghrib: "19:26",
    isha: "21:31"
  },
  13: {
    fajr: "03:43",
    shoruk: "06:05",
    dhuhr: "12:49",
    asr: "16:12",
    maghrib: "19:23",
    isha: "21:27"
  },
  14: {
    fajr: "03:44",
    shoruk: "06:07",
    dhuhr: "12:49",
    asr: "16:10",
    maghrib: "19:20",
    isha: "21:23"
  },
  15: {
    fajr: "03:47",
    shoruk: "06:09",
    dhuhr: "12:48",
    asr: "16:08",
    maghrib: "19:17",
    isha: "21:19"
  },
  16: {
    fajr: "03:50",
    shoruk: "06:12",
    dhuhr: "12:48",
    asr: "16:06",
    maghrib: "19:14",
    isha: "21:16"
  },
  17: {
    fajr: "03:54",
    shoruk: "06:14",
    dhuhr: "12:47",
    asr: "16:04",
    maghrib: "19:11",
    isha: "21:12"
  },
  18: {
    fajr: "03:57",
    shoruk: "06:16",
    dhuhr: "12:47",
    asr: "16:02",
    maghrib: "19:08",
    isha: "21:08"
  },
  19: {
    fajr: "04:00",
    shoruk: "06:18",
    dhuhr: "12:47",
    asr: "16:00",
    maghrib: "19:05",
    isha: "21:05"
  },
  20: {
    fajr: "04:03",
    shoruk: "06:21",
    dhuhr: "12:46",
    asr: "15:58",
    maghrib: "19:02",
    isha: "21:01"
  },
  21: {
    fajr: "04:06",
    shoruk: "06:23",
    dhuhr: "12:46",
    asr: "15:55",
    maghrib: "18:59",
    isha: "20:57"
  },
  22: {
    fajr: "04:09",
    shoruk: "06:25",
    dhuhr: "12:46",
    asr: "15:53",
    maghrib: "18:56",
    isha: "20:54"
  },
  23: {
    fajr: "04:12",
    shoruk: "06:27",
    dhuhr: "12:45",
    asr: "15:51",
    maghrib: "18:53",
    isha: "20:50"
  },
  24: {
    fajr: "04:15",
    shoruk: "06:30",
    dhuhr: "12:45",
    asr: "15:49",
    maghrib: "18:50",
    isha: "20:47"
  },
  25: {
    fajr: "04:18",
    shoruk: "06:32",
    dhuhr: "12:45",
    asr: "15:47",
    maghrib: "18:47",
    isha: "20:44"
  },
  26: {
    fajr: "04:21",
    shoruk: "06:34",
    dhuhr: "12:44",
    asr: "15:45",
    maghrib: "18:44",
    isha: "20:40"
  },
  27: {
    fajr: "04:23",
    shoruk: "06:37",
    dhuhr: "12:44",
    asr: "15:43",
    maghrib: "18:41",
    isha: "20:37"
  },
  28: {
    fajr: "04:26",
    shoruk: "06:39",
    dhuhr: "12:44",
    asr: "15:41",
    maghrib: "18:38",
    isha: "20:34"
  },
  29: {
    fajr: "04:29",
    shoruk: "06:41",
    dhuhr: "12:43",
    asr: "15:38",
    maghrib: "18:35",
    isha: "20:30"
  },
  30: {
    fajr: "04:32",
    shoruk: "06:43",
    dhuhr: "12:43",
    asr: "15:36",
    maghrib: "18:32",
    isha: "20:27"
  }
};